<template>
  <div>
    <signature-header />
    <google-translate />
    <div class="page-wrapper document-view-details">
      <div class="container"  ref="extraHealthVerification">
        <div class="row body-main-row justify-content-center">
          <div class="col-md-8 member_dashboard">
            <b-skeleton-table
                v-if="skeletonLoader"
                :rows="15"
                :columns="1"
                :table-props="{ striped: true }"
            >
            </b-skeleton-table>
            <div
                class="document-view-body"
                v-if="!skeletonLoader"
            >

              <div style="padding: 16%" v-if="isComplete">

                <div>
                  <div class="container">
                    <div class="row justify-content-center">
                      <div class="col-xxl-7 col-xl-7 col-lg-7 col-md-8">
                        <div class="success-block text-center">
                          <div class="success-image mb-4">
                            <img
                                src="@/assets/images/success.svg"
                                class="img-fluid"
                                id="registration_success_image"
                            />
                          </div>
                          <p><strong>{{
                              alreadySubmitted ? "Signature has already been submitted" : "Signature submitted successfully."
                            }}</strong></p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style="padding: 16%" v-if="!isPolicyActive">
                <p><strong>{{ inactiveMessage }}</strong></p>
              </div>


              <div v-if="!isComplete && isPolicyActive">

                <div class="directory-block signatureData">
                  <h2>Dear {{ data?.primary_info?.first_name }} {{ data?.primary_info?.last_name }},</h2>
                </div>

                <div class="signatureTerms">
                  <p>Congratulations, your enrollment is processed. To complete the enrollment please
                    submit your signature below.</p>
                </div>

                <div class="signatureTerms">
                  <h3><strong>Terms & Conditions</strong></h3>

                  <ul>
                    <li>The member shall agree that the Plan is final as written and will be administrated as such.</li>
                    <li>The member shall agree that all plan and eligibility changes must be approved by the Plan
                      Supervisor.
                    </li>
                    <li>The member shall agree to be drafted on the payment date noted in the confirmation email
                      monthly.
                    </li>
                    <li>The member shall submit a request for termination in advance of the premium draft corresponding to
                      the termination date. All terminations will be processed effective the last day of the month.
                    </li>
                    <li>The member shall make up any failed payment within 30 days of the scheduled draft date. Failure to
                      remit payment within this time frame will result in plan termination.
                    </li>
                  </ul>


                  <ul>
                    <h3><strong>Billing Agreement</strong></h3>
                    <li>
                      <strong>Overview</strong><br>
                      This Billing Agreement (“Agreement”) is entered into between Extra Health (“Company”) and you
                      (“Customer”). By entering into this Agreement, Customer authorizes the Company to charge the
                      Customer s credit card on a recurring basis as outlined below.
                    </li>
                    <li>
                      <strong>Payment Terms</strong><br>
                      <strong>Initial Payment:</strong> The first month’s payment will be billed <strong>on the date of
                      enrollment</strong> to cover services for the initial month.<br>
                      <strong>Recurring Billing:</strong> Payments are scheduled to be charged on the <strong>15th of each
                      month</strong> to cover services for the following month.<br>
                      <strong>Recurring Attempts:</strong> If the initial charge on the 15th fails, the Company will make
                      additional attempts to process the payment on:<br>
                      <ul>
                        <li><strong>20th of the month</strong></li>
                        <li><strong>25th of the month</strong></li>
                        <li><strong>30th of the month</strong></li>
                        <li><strong>1st of the following month</strong></li>
                        <li><strong>3rd of the following month</strong></li>
                        <li><strong>5th of the following month</strong></li>
                      </ul>
                      <strong>Account Termination:</strong> If the charge remains unpaid after the final attempt on the
                      30th, the Customer’s account will be <strong>terminated immediately</strong>.
                    </li>
                    <li>
                      <strong>Payment Method</strong><br>
                      Customer authorizes the Company to charge their credit card provided. It is the Customer’s
                      responsibility to ensure that the credit card information provided is valid and up-to-date.
                    </li>
                    <li>
                      <strong>Notification of Failed Payment</strong><br>
                      The Company will notify the Customer via email within <strong>24 hours</strong> of a failed payment
                      attempt. It is the Customer’s responsibility to ensure the Company has updated contact information
                      to receive notifications.
                    </li>
                    <li>
                      <strong>Account Termination</strong><br>
                      Accounts terminated due to non-payment after the final charge attempt on the 30th are subject to the
                      following:<br>
                      <ul>
                        <li>Immediate suspension of services.</li>
                        <li>Possible reactivation fees if the account is reinstated.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Cancellation Policy</strong><br>
                      The Customer may cancel this billing agreement at any time by providing a written notice to the
                      Company at least <strong>10 days</strong> prior to the next billing cycle. Cancellation requests
                      must be sent to <a href="mailto:support@enrollprime.com">support@enrollprime.com</a>. Any payments
                      already processed are non-refundable.
                    </li>
                    <li>
                      <strong>Agreement Modifications</strong><br>
                      The Company reserves the right to modify the terms of this Agreement with 30 days’ notice. Continued
                      use of the services after such notice constitutes acceptance of the new terms.
                    </li>

                    <li>
                      <strong>Customer Acknowledgment</strong><br>
                      By signing below, the Customer acknowledges and agrees to the terms outlined in this Billing
                      Agreement.
                    </li>

                    <br>
                    <h3><strong>Agreement, Application and Authorization</strong></h3>
                    <div>
                      <div>
                        <div id="headerEnroll" v-html="data?.enrollment_text?.enrollment_text_head" class="extra-health-heading mt-3"></div>
                        <div  id="bodyEnroll" v-html="data?.enrollment_text?.enrollment_text_body" class="mt-3"></div>
                      </div>
                    </div>
                  </ul>

                  <label class="checkbox-inline">
                    <input type="checkbox" v-model="is_term_agree"> I Agree Terms & Conditions
                  </label>
                </div>
                <div class="signature">
                  <div class="signature_title">
                    <p>
                      <b>Application Signature (Required): </b>
                      <span
                      >(Sign Name using your mouse or touch screen in the box
                      below)</span
                      >
                    </p>
                  </div>
                  <signature-pad ref="signpad" @sign="getSign"></signature-pad>
                  <div
                      v-if="isSignRequired"
                      tabindex="-1"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                      style="display: block"
                      class="invalid-feedback"
                  >
                    Sign is required.
                  </div>
                  <p class="osf">
                    <em>With signature your enrollment will be complete.</em>
                  </p>
                  <br/>
                  <div class="text-center">
                    <button
                        @click="submitSign()"
                        type="button"
                        class="submitSignature"
                        :disabled="!is_term_agree"
                    >
                      <b-spinner v-if="signatureLoader == true" small></b-spinner>
                      Submit Signature
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import axios from "axios";
import SignaturePad from "@/components/SignaturePad";
import endpoint from "@/resoruce/endpoint";
import Helper from "@/resoruce/Helper";
import GoogleTranslate from "../components/GoogleTranslate";
import html2canvas from "html2canvas";
import SignatureHeader from "@/components/SignatureHeader";

/*eslint-disable*/
export default {
  name: "PolicySignature",
  components: {
    SignaturePad,
    GoogleTranslate,
    SignatureHeader
  },
  data: () => ({
    data: [],
    skeletonLoader: false,
    sign: "",
    policyId: "",
    enrollment_id: "",
    isSignRequired: false,
    sign_hash: "",
    isComplete: false,
    alreadySubmitted: false,
    signatureLoader: false,
    is_term_agree: false,
    isPolicyActive: true,
    inactiveMessage: '',
    carrierSpecialMessage: ''
  }),
  methods: {
    async getData() {
      let config = {
        method: 'get',
        url: `${endpoint.BENEFIT_STORE_COMMON_URL}/api/v1/get-temp-enrollment-info?temp_id=${this.policyId}`,
        headers: { 'Authorization': 'Basic ' + process.env.VUE_APP_CLIENT_API_TOKEN},
      };
      await axios(config)
          .then((res) => {
            console.log(res)
            this.data = res.data.data;
            this.enrollment_id = res.data.data.enrollment_id;
            if (res.data.data.has_already_submitted === true) {
              this.isComplete = true;
            }
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            this.skeletonLoader = false;
            // loader.hide();
          });
    },
    async submitSign() {
      if (this.sign === "") {
        this.isSignRequired = true;
        setTimeout(() => {
          this.captureScreenShotCanvas('member-signature-validation-check')
        }, 1000)
        return;
      }

      this.signatureLoader = true;
      this.isSignRequired = false;
      this.captureScreenShotCanvas('member-signature-validation-submit')
      const data = {
        enrollment_id: this.enrollment_id,
        sign: this.sign,
      };
      let config = {
        method: 'post',
        url: `${endpoint.BENEFIT_STORE_COMMON_URL}/api/v1/save-temp-enrollment-sign`,
        headers: { 'Authorization': 'Basic ' + process.env.VUE_APP_CLIENT_API_TOKEN},
        data: data
      };
      try {
        const res = await axios(config);
        this.isComplete = true;
        Helper.infoMessage(this, "success", res.data.message);
      } catch (err) {
        Helper.infoMessage(this, "error", err.response?.data?.message || "An error occurred");
      } finally {
        this.skeletonLoader = false;
        this.isSignRequired = false;
        this.$refs.signpad.clear();
        this.signatureLoader = false;
        setTimeout(() => {
          this.captureScreenShotCanvas('member-signature-success')
        }, 1000)
      }
    },

    getSign(sign = "") {
      this.sign = sign;
      this.isSignRequired = false;
    },
    async captureScreenShotCanvas (captureScreenShotName) {
      const el = this.$refs.extraHealthVerification;
      (async () => {
        this.saveScreenShot((await html2canvas(el, {
          scrollY: -window.scrollY,
          useCORS: true,
          scale: 2,
        })).toDataURL('image/png'), captureScreenShotName);
      })()
    },
    saveScreenShot (image, name) {
      let app = this;
      let loader = this.$loading.show();
      let data = {
        "enrollment_id" : app.enrollment_id,
        "name" : name,
        "image" : image
      };
      let config = {
        method: 'post',
        url: `${endpoint.BENEFIT_STORE_COMMON_URL}/api/v1/save-screenshot`,
        headers: { 'Authorization': 'Basic ' + process.env.VUE_APP_CLIENT_API_TOKEN},
        data : data
      };
      axios(config, {
      })
          .then(function (response) {
            if (response.data.status == 'success') {
              console.log('screenshot saved');
            }
          })
          .catch(function (error) {
            console.log('screenshot not saved');
            console.log(error);
          }).finally(() => {
        loader.hide();
      });
    },
  },
  created() {
    this.sign_hash = (Math.random() + 1).toString(36).substring(7);
    this.policyId = this.$route.params.policyID
    this.getData();
  },
};
</script>
<!--                <p>This is to verfiy your email <span class="font-weight-bold">{{-->
<!--                    data.contact_info.email_address-->
<!--                  }}</span> to proceed further. We will notify your further through this email. Please validate by your-->
<!--                  signature below for confirmation.</p>-->
<style>
.document-view-details {
  padding: 0;
  color: #212529;
}

.document-view-body {
  background: #fff;
  box-shadow: 0 2px 15px rgb(216 227 235 / 33%);
  padding: 30px;
  border-radius: 15px;
}

.document-view-body p {
  font-size: 14px;
  margin-bottom: 10px;
}

.new-rate-details {
  padding: 15px;
  max-width: 800px;
  margin-bottom: 13px;
  background: #f3f7fa;
  border-radius: 10px;
  margin-top: 15px;
  font-size: 14px;
}

.document-view-body .osf {
  opacity: 0.7;
  margin-bottom: 5px;
}

.directory-block h2 {
  font-size: 18px;
  font-weight: bold;
  color: #212529;
}

.new-rate-details ul {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
}

.new-rate-details ul li {
  display: inline-block;
}

.new-rate-details strong {
  color: #03c3ec;
}

.doc-footer p {
  margin-bottom: 4px;
}

.doc-footer p:first-child {
  margin-top: 2%;
}

.doc-footer .osf {
  margin-bottom: 2px;
}

.elevate-logo {
  width: 20%;
  display: block;
  margin: 0px auto;
  margin-top: 2%;
}

.signatureTerms h2 {
  font-size: 17px;
  font-weight: 600;
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
  color: #212529;
}

.signatureTerms ul {
  font-size: 14px;
  list-style: auto;
  padding-left: 20px;
}

.signatureTerms ul li {
  list-style: initial;
  padding-bottom: 5px;
}

.signatureTerms .checkbox-inline {
  font-size: 14px;
}

.signatureTerms input {
  margin-right: 10px;
}

.signatureData {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.signatureData figure {
  font-size: 14px;
  background: #f3f6f8;
  padding: 5px 13px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 0;
}

.submitSignature {
  background: #29bcff;
  border: 0px;
  padding: 10px 30px;
  color: #fff;
  font-size: 14px;
  outline: none;
  border-radius: 6px;
}

.signature .clear {
  background: #333;
  color: #fff;
  padding: 5px 30px;
  float: inherit;
}

.policy-Info ul,
.policy-Info ul li {
  display: block;
  font-size: 13px;
  line-height: 20px;
}

.policy-Info h4 {
  font-size: 14px;
  font-weight: 700;
  color: #212529;
}

button.submitSignature:disabled {
  background: grey;
}

.carrier-message-container {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  border-radius: 8px;
  padding: 12px 10px;
  margin-top: 15px;
  text-transform: capitalize;
  text-align: center;
  font-size: 15px;
  width: 100%;
}
</style>
<style scoped>
#footer {
  padding-top: 50px !important;
}

.extra-health-heading {
  font-weight: 500;
  font-size: 1rem;
}
#bodyEnroll > h3  {
  font-size: 8px !important;
  font-weight: lighter !important;
  color: #0fc7ec !important;
}

</style>